exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-count{display:flex;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:center;padding:16px;height:100%}.widget-count div{margin:0 8px 0 8px}.widget-count .value{font-size:32px;font-weight:300;text-align:center}", ""]);

